import Vue from 'vue';
import { getSaProfile, unbindSa } from '../../../services/crmService/mySaService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  saData: null
};

// getters
const getters = {};

// actions
const actions = {
  // 取得CA Profile
  async getSaProfileHandler({ commit }) {
    const data = await getSaProfile();
    commit('setSaData', data.data);
  },
  // 解除與CA綁定
  async unbindSaHandler() {
    await unbindSa();
  }
};

// mutations
const mutations = {
  setSaData(state, data) {
    Vue.set(state, 'saData', data.personnel);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
